<template>
  <v-app :class="styleBorder +' pt-10'">
    <v-main v-if="loadingStory.status==true">
      <v-container fill-height grid-list-md text-xs-center>
        <v-row justify="center">
          <v-col align="center" cols="12" class="px-10">
            <v-img :src="require('@/assets/warmness_illustration.jpg')"></v-img>
          </v-col>
          <v-col align="left" cols="12" class="px-16">
            {{$t('thankYou')}}
          </v-col>
          
          <v-col align="left" cols="12" class="px-16">
            {{loadingStory.text}}
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col align="center" class="px-16">
            <v-progress-circular indeterminate color="primaryVariant"></v-progress-circular>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col align="left" cols="12" class="px-16">

          </v-col>
        </v-row>
      </v-container>
    </v-main>



    <v-main v-else-if="loadingJourney.status==true">
      <v-container fill-height grid-list-md text-xs-center>
        <v-row justify="center">
          <v-col align="center" cols="12" class="px-10">
            <v-img :src="require('@/assets/warmness_illustration.jpg')"></v-img>
          
          </v-col>
          <v-col align="left" cols="12" class="px-16">
            <strong><h2>{{loadingJourney.text}}</h2></strong><!---->
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col align="left" cols="12" class="px-16">
            {{loadingJourney.description}}
          </v-col>
        </v-row>
                <v-row align=center class="px-16">
          <v-col cols=4 align="right">
                        <v-img :src="require('@/assets/loader.gif')"></v-img>

          </v-col>
          <v-col cols=8 align="left">
                  {{$t('loading')}}...
          </v-col>
        </v-row>
      </v-container>
    </v-main>
        <v-main v-else-if="loading==true">
      <menuapplication class="mt-0 pt-0 mb-0 pb-0" title="MEMEX" :menu="true" />
          <v-img style="margin-top:20vh;align-right:auto;align-left:auto" :src="require('@/assets/loader.gif')"></v-img>
      <router-view />
    </v-main>
    <v-main v-else>
      <menuapplication class="mt-0 pt-0 mb-0 pb-0" v-if="logged" title="MEMEX" :menu="true" />
        <!--loader :loading="loading"></loader-->
      <router-view />
    </v-main>

    <!-- message pre upload-->
    <v-dialog class="pb-15" v-model="getDialogPreUpload.active"
      :color="getDialogPreUpload.color" :timeout="-1">
      <v-card class="white--text" v-if="getDialogPreUpload.isSuccess==true&&getDialogPreUpload.active">
        <v-card-actions class="colorSuccess justify-end">
          <v-btn color="white" text @click="closeDialogPreUpload()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-container class="colorSuccess justify-end" px-5>
          <v-row :color="getDialogPreUpload.color">
            <v-col>
                          <v-img :src="require('@/assets/success_warmness_illustration.jpg')"></v-img>

              <!--span style="font-size:4rem">{{$t("theUploadedHasSuccess_emoticon")}}</span-->
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              {{$t("theUploadedHasSuccess_esclamation")}}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              {{$t("theUploadedHasSuccess_title")}}
            </v-col>
            <v-col cols=12>
              <span v-html="getDialogPreUpload.text"></span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <hr/>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              {{$t("theUploadedHasSuccess_description")}}
            </v-col>
          </v-row>
        </v-container>

      </v-card>
      <v-card v-if="getDialogPreUpload.isSuccess==true&&getDialogPreUpload.active">
        <v-card-actions class="colorFailure justify-end">
          <v-btn text @click="closeDialogPreUpload()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-container class="colorFailure" px-5>
          <v-row>
            <v-col>
              <v-img :src="require('@/assets/failure_warmness_illustration.jpg')"></v-img>
              <!--span style="font-size:4rem">{{$t("theUploadedHasFailed_emoticon")}}</!--span-->
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              {{$t("theUploadedHasFailed_esclamation")}}
            </v-col>

          </v-row>
          <v-row>
            <v-col>
              {{$t("theUploadedHasFailed_title")}}
            </v-col>
            <v-col cols=12>
              <span v-html="getDialogPreUpload.text"></span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <hr />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              {{$t("theUploadedHasFailed_description")}}
            </v-col>
          </v-row>
        </v-container>


      </v-card>
    </v-dialog>
    <!--message-->
    <v-snackbar class="pb-15" :absolute="true" v-if="getSnackbar!=null" :value="getSnackbar.active" :snackbar-top="0"
      :color="getSnackbar.color" :timeout="-1">
      <v-container class="ma-0 pa-0 text-center">
        <v-row class="ma-0 pa-0" justify="center" align="center">
          <v-col cols="10">
            <span v-html="getSnackbar.text"></span>
          </v-col>
          <v-col cols="2">
            <v-btn icon text @click="closeSnackbar()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-snackbar>

  </v-app>
</template>

<script>

import menuapplication from "@/components/headerapplication";
//import loader from '@/components/loader.vue'
//import { mapState } from 'vuex';

export default {
  name: 'App',

  data() {
    return {

      timeout: 6000,
    }
  },
mounted(){
  this.snackbar = null
/*check if loading is active after 720 seconds after arrive on the page*/
if (Math.floor(Date.now() / 1000)-this.$store.getters.getLoadingTimeStampStart< 720){
  this.$store.dispatch('setLoadingStory', {status:false,text:''})
  this.$store.dispatch('setLoadingJourney', {status:false,text:''})
}
  setTimeout(() =>{this.closeSnackbar()}, 7000)

},
  computed: {
  styleBorder:
    function () {
    if (this.$route.name=='mapStoriesIframe')
        return '';
        return 'maxwidth'
    },
    getDialogPreUpload:{
      get: function () {
        return this.$store.getters.getDialogPreUpload;
      }
    },
    getSnackbar: {
      get: function () {
        let getSnackbar = this.$store.getters.getSnackbar
        if (getSnackbar.text == "storySuccess") {
          getSnackbar.text = this.$t('theStoryCreateOK')
        }
        else if (getSnackbar.text == "storyError") {
          getSnackbar.text = this.$t('theStoryCreateFail')
        }
        else if (getSnackbar.text == "storyDraft") {
          getSnackbar.text = this.$t('theStoryDraftOK')
        }
        return getSnackbar
      }
    },
    logged: {
      get: function () {
        return this.$store.getters.getAccessToken;
      }
    },
    loading: {
      get: function () {
        return this.$store.getters.getLoading;
      }
    },
    loadingStory: {
      get: function () {
        return this.$store.getters.getLoadingStory;
      }
    },
    loadingJourney: {
      get: function () {
        return  this.$store.getters.getLoadingJourney.status;
      }
    }
  },
  components: {
    menuapplication
    //,loader
  },
  methods: {
    closeDialogPreUpload () {
      this.$store.dispatch("setDialogPreUpload",{color:'',text:'',active:false,isSuccess:false})
    },
    closeSnackbar() {
            this.$store.dispatch("setSnackbar", {
            color: '',
            text: '',
            active: false
          })
    }
  }
};
</script>
<style>
/*less margin between vue-wysiwyg editor*/
.editr--toolbar a{
width: 8vw!important;
}
.leaflet-control-zoom.leaflet-bar.leaflet-control{
margin-top: calc(60px + 5vh);
}
.colorSuccess{
background-color: #38737A;
color:white;
}
.colorFailure{
  background-color: #E70A04;
  color: white;
}

/** height for srop down list**/
.v-list-item .v-list-item__subtitle, .v-list-item .v-list-item__title{
  line-height: 1.4;
}
/** memex main font family**/

html, body {
  font-family: 'Segoe UI', sans-serif;
}
#app {
  font-family: 'Segoe UI', sans-serif;
}
.memexStoryTitle{
  color:#00316f;
  font-weight: bold;
  font-size:1.4rem;
  /*text-transform: uppercase;*/
}
.v-toolbar{
  box-shadow:none!important;
}
.v-window__prev, .v-window__next {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    position: absolute;
    margin: 0 16px;
    top: calc(25% - 20px)!important;
    z-index: 1;
}
.maxwidth{
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
}
.contentStyle {
  width: 100%;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.itemMenu{
  color: rgba(0, 0, 0, 0.87);
  white-space: nowrap;
}
a {
  text-decoration: none;
}
.v-btn__content { width: 100%; white-space: normal; }

.floatingBtn{
  border-radius: 100px;
  z-index: 2;
}
.titletabs{
  font-size:0.9rem;
}
.v-application--wrap{
  overflow-x: hidden
}
/*
html {
  height: 100vh;
  height: -webkit-fill-available;
}
body,
body>div,
.v-application {
  height: 100vh;
  height: -webkit-fill-available;
}
.v-application--wrap {
  min-height: 100vh!important;
  min-height: -webkit-fill-available!important;
}
*/
.v-application p {
    margin-bottom: 12px;
}
.btncreatenewstory{
  font-size: 0.7rem;
  text-transform: uppercase;
}

@media only screen and (min-width: 700px) {
  .v-btn--absolute.v-btn--right, .v-btn--fixed.v-btn--right{
    right: calc((100% - 700px)/2 + 20px)
  }
}

/** iphone X **/
@media only screen
    and (device-width : 375px) 
    and (device-height : 812px) 
    and (-webkit-device-pixel-ratio : 3) { }

/** iphone 8 **/
@media only screen
    and (device-width : 375px) 
    and (device-height : 667px) 
    and (-webkit-device-pixel-ratio : 2) { 
    }

/** iphone 8 Plus**/
@media only screen 
    and (device-width : 414px) 
    and (device-height : 736px) 
    and (-webkit-device-pixel-ratio : 3) { }
</style>